import api from '../services/api';

/**
 * รายชื่อสาขาวิชาของนักศึกษาที่มีอยู่จริงในระบบ TPMS (จากฐานข้อมูลตาราง students)
 * อ้างอิงจากระบบจัดการข้อมูลนักศึกษา (Student Management System)
 */
export const DEFAULT_STUDENT_MAJORS: string[] = [
  'การประถมศึกษา',
  'การศึกษา (ชีววิทยา)',
  'การศึกษา (ฟิสิกส์)',
  'การศึกษา (อุตสาหกรรมศิลป์)',
  'การศึกษาปฐมวัย',
  'คณิตศาสตร์',
  'คอมพิวเตอร์',
  'ดนตรีศึกษา',
  'พลศึกษา',
  'ภาษาจีน',
  'ภาษาอังกฤษ',
  'ภาษาไทย',
  'วิทยาศาสตร์ทั่วไป',
  'ศิลปศึกษา',
  'สังคมศึกษา',
  'เคมี'
];

/**
 * ดึงรายชื่อสาขาวิชาของนักศึกษาแบบ Dynamic จากระบบ
 * หากเชื่อมต่อ API ไม่ได้ จะใช้ค่าตั้งต้น 16 สาขาวิชาที่มีอยู่จริงในระบบ
 */
export async function fetchStudentMajors(): Promise<string[]> {
  try {
    const res = await api.get('/students/majors');
    if (res.data && Array.isArray(res.data.majors)) {
      const list = res.data.majors
        .map((m: any) => (typeof m === 'string' ? m : m.major))
        .filter((m: any): m is string => Boolean(m && typeof m === 'string' && m.trim()));
      if (list.length > 0) {
        const set = new Set<string>([...DEFAULT_STUDENT_MAJORS, ...list]);
        return Array.from(set).sort((a, b) => a.localeCompare(b, 'th'));
      }
    }
  } catch (err) {
    console.warn('Failed to fetch student majors from API, using default student majors:', err);
  }
  return [...DEFAULT_STUDENT_MAJORS];
}
